import React, { useEffect, useRef, useState } from 'react';
import './Carousel.scss';
import image2 from './../assets/auth/references/image-2.png';
import image3 from './../assets/auth/references/image-3.png';
import image4 from './../assets/auth/references/image-4.png';
import image5 from './../assets/auth/references/image-5.png';
import image7 from './../assets/auth/references/image-7.png';
import image8 from './../assets/auth/references/image-8.png';
import image9 from './../assets/auth/references/image-9.png';
import image10 from './../assets/auth/references/image-10.png';
import image11 from './../assets/auth/references/image-11.png';
import image12 from './../assets/auth/references/image-12.png';
import image13 from './../assets/auth/references/image-13.png';
import image14 from './../assets/auth/references/image-14.png';

const images = [
  image2, image3, image4, image5,
  image7, image8, image9, image10, image11, image12,
  image13, image14,
];

const AuthCarousel = () => {
  const carouselRef = useRef<HTMLDivElement>(null);
  const trackRef = useRef<HTMLDivElement>(null);
  const [duplicatedImages] = useState(() => images.concat(images)); // duplicate once for seamless loop

  useEffect(() => {
    const recalc = () => {
      const track = trackRef.current;
      if (!track) return;
      // Half of the track scroll width equals one full set of images
      const distance = track.scrollWidth / 2;
      track.style.setProperty('--scroll-distance', `${distance}px`);
    };
    // Recalc after mount and when assets load
    recalc();
    const timer = setTimeout(recalc, 100); // minor delay for image layout
    window.addEventListener('resize', recalc);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', recalc);
    };
  }, []);

  return (
    <div className="carousel" ref={carouselRef}>
      <div className="carousel-track" ref={trackRef}>
        {duplicatedImages.map((src, index) => (
          <div className="carousel-item" key={index}>
            <img src={src} alt={`Image ${index + 1}`} className="carousel-image" onLoad={() => {
              const track = trackRef.current; if (track) { const d = track.scrollWidth / 2; track.style.setProperty('--scroll-distance', `${d}px`); }
            }} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AuthCarousel;
